module.exports = __webpack_public_path__ + "assets/fonts/41b63765-457f-4348-bb1e-ba3ea934351c.69f39d69.eot";